import { render } from "./DefaultWrapper.vue?vue&type=template&id=07432f39"
import script from "./DefaultWrapper.vue?vue&type=script&lang=js"
export * from "./DefaultWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script